import {
    SET_ACCOUNT_MANAGERS,
    SET_USER_LIST,
    ADD_TO_USER_LIST,
    UPDATE_USER_DETAILS
} from '../types';

const INITIAL_STATE = {
    accountManagers: [],
    list: []
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_USER_LIST:
            return { ...state, list: action.payload }
        case ADD_TO_USER_LIST:
            return { ...state, list: (state.list || []).concat([ action.payload ]) }
        case UPDATE_USER_DETAILS:
            return { ...state, list: (state.list || []).filter(x => x.id !== action.payload.id).concat([ action.payload ]) }
        case SET_ACCOUNT_MANAGERS:
            return { ...state, accountManagers: action.payload }
        default:
            return state;
    }
}
